import { keyframes } from '@emotion/core';
import styled from '@emotion/styled';
import { Icon, Box, Link } from '@qga/roo-ui/components';
import { themeGet } from 'styled-system';

const shareAnimation = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.8);
  }
  100% {
    transform: scale(1);
  }
`;

export const ShareIcon = styled(Icon)`
  color: ${themeGet('colors.greys.charcoal')};
  transform-origin: center center;
  animation: ${shareAnimation} 0.25s ease-in-out;
`;

export const ShareCtaStyling = styled(Box)`
  background-color: ${themeGet('colors.snow')};
  border-radius: ${themeGet('radii.rounded')};
  box-shadow: ${themeGet('shadows.hard')};
  display: block;
  padding: ${themeGet('space.3')};
  transition: box-shadow 0.2s;

  &:focus {
    outline: none;
    box-shadow: ${themeGet('focus.boxShadow')};
  }

  &:hover {
    box-shadow: ${themeGet('shadows.hover')};
  }
`;

export const TooltipWrapper = styled(Box)`
  box-shadow: ${themeGet('shadows.tooltip')};
  color: ${themeGet('colors.greys.steel')};
  background-color: ${themeGet('colors.white')};
  padding: ${themeGet('space.6')} ${themeGet('space.8')};
  border-radius: ${themeGet('radii.default')};
  text-align: left;
`;

export const ShareLink = styled(Link)`
  width: 100%;
  border: ${themeGet('borders.1')} ${themeGet('colors.greys.porcelain')};
  padding: ${themeGet('space.3')} ${themeGet('space.4')};
  color: ${themeGet('colors.greys.charcoal')};
  display: flex;
  justify-content: space-between;
  margin-bottom: ${themeGet('space.3')};
`;

export const CopyNotification = styled(Box)`
  position: absolute;
  width: 50%;
  left: 25%;
  top: 50%;
  box-shadow: ${themeGet('shadows.hard')};
  border-radius: ${themeGet('radii.default')};
  text-align: center;
  background-color: ${themeGet('colors.greys.dusty')};
  pointer-events: none;
`;
